import { render, staticRenderFns } from "./CheckoutSizingModalComponent.html?vue&type=template&id=69498528&"
import script from "./CheckoutSizingModalComponent.js?vue&type=script&lang=js&"
export * from "./CheckoutSizingModalComponent.js?vue&type=script&lang=js&"
import style0 from "./CheckoutSizingModalComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports